import React from 'react';
import { AuthProvider } from '@/contexts/AuthContext';
import '@styles/index.css';
import { AppRouter } from './appRouter';

function App(): React.ReactElement {
  return (
    <AuthProvider>
      <AppRouter />
    </AuthProvider>
  );
}

export default App;
